"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _immutable = _interopRequireDefault(require("immutable"));

var _InfiniteTiles = _interopRequireDefault(require("FileManagerLib/components/browser/InfiniteTiles"));

var _ShutterstockDetails = _interopRequireDefault(require("FileManagerLib/components/browser/ShutterstockDetails"));

var _Shutterstock = require("FileManagerLib/actions/Shutterstock");

var _Constants = require("FileManagerLib/Constants");

var _Actions = require("FileManagerLib/actions/Actions");

var _Panel = require("FileManagerLib/selectors/Panel");

var Shutterstock =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Shutterstock, _Component);

  function Shutterstock(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Shutterstock);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Shutterstock).call(this, props));
    _this.renderTile = _this.renderTile.bind((0, _assertThisInitialized2.default)(_this));
    _this.getRenderer = _this.getRenderer.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderStock = _this.renderStock.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderStockDetail = _this.renderStockDetail.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSelect = _this.handelSelect.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCloseStockDetail = _this.handleCloseStockDetail.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInsert = _this.handleInsert.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Shutterstock, [{
    key: "handelSelect",
    value: function handelSelect(event, image) {
      var _this$props = this.props,
          onSelect = _this$props.onSelect,
          onTrackInteraction = _this$props.onTrackInteraction;
      onTrackInteraction('Browse Shutterstock', 'clicked-image-preview');
      onSelect(image);
    }
  }, {
    key: "handleInsert",
    value: function handleInsert(file) {
      var onInsert = this.props.onInsert;
      onInsert(file);
    }
  }, {
    key: "handleCloseStockDetail",
    value: function handleCloseStockDetail() {
      var usageTrackingMeta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var onSelect = this.props.onSelect;
      onSelect(null, usageTrackingMeta);
    }
  }, {
    key: "getRenderer",
    value: function getRenderer(tile) {
      switch (tile.get('type')) {
        case _Constants.CellTypes.FILE_DETAIL:
          return this.renderStockDetail;

        default:
          return this.renderStock;
      }
    }
  }, {
    key: "renderStockDetail",
    value: function renderStockDetail(tile) {
      var onUpdateHeight = this.props.onUpdateHeight;
      return _react.default.createElement(_ShutterstockDetails.default, {
        tile: tile,
        onClose: this.handleCloseStockDetail,
        onInsert: this.handleInsert,
        onUpdateHeight: onUpdateHeight
      });
    }
  }, {
    key: "renderStock",
    value: function renderStock(tile) {
      var _this2 = this;

      var _tile$toObject = tile.toObject(),
          image = _tile$toObject.image,
          width = _tile$toObject.width,
          height = _tile$toObject.height;

      return _react.default.createElement("img", {
        src: image.get('smallPreviewUrl'),
        width: width,
        height: height,
        onClick: function onClick(event) {
          _this2.handleSelect(event, image);
        }
      });
    }
  }, {
    key: "renderTile",
    value: function renderTile(tile) {
      var renderer = this.getRenderer(tile);
      return renderer(tile);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          tiles = _this$props2.tiles,
          total = _this$props2.total,
          onLoadMoreImages = _this$props2.onLoadMoreImages;
      return _react.default.createElement(_InfiniteTiles.default, {
        onLoadMoreImages: onLoadMoreImages,
        tileRenderer: this.renderTile,
        tiles: tiles,
        total: total
      });
    }
  }]);
  return Shutterstock;
}(_react.Component);

Shutterstock.propTypes = {
  tiles: _react.PropTypes.instanceOf(_immutable.default.List),
  total: _react.PropTypes.number.isRequired,
  onSelect: _react.PropTypes.func.isRequired,
  onInsert: _react.PropTypes.func.isRequired,
  onLoadMoreImages: _react.PropTypes.func.isRequired,
  onUpdateHeight: _react.PropTypes.func.isRequired,
  onTrackInteraction: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    selectedStockFile: (0, _Panel.getSelectedStockFile)(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onTrackInteraction: function onTrackInteraction(name, action, meta) {
      dispatch((0, _Actions.trackInteraction)(name, action, meta));
    },
    onSelect: function onSelect(image) {
      dispatch(image ? (0, _Shutterstock.selectStockFile)(image) : (0, _Shutterstock.deselectStockFile)(null));
    },
    onUpdateHeight: function onUpdateHeight(image, height) {
      dispatch((0, _Actions.updateDetailHeight)(image, height));
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Shutterstock);

exports.default = _default;
module.exports = exports.default;